import React from 'react';
import moment from 'moment';
import Container from "../editor/container"
import parseContent from '../editor/parseContent'

class Component extends React.Component {

  initialState = {
    closed: false
  }

  state = this.initialState

  componentWillMount() {
    this.setState(this.initialState)
    if (this.props.apiState.initial) {
      this.props.api("news/find_by_user");
    }
  }

  close = (e) => {
    e.preventDefault();
    this.setState({closed: true})

    let card = this.props.items[0]
    this.props.api("news/popup_close", {id: card.news_id});
  }

  render() {
    let card = this.props.items[0]
    let { closed } = this.state    
    if (!card || closed) return "";
    if (parseInt(this.props.user.last_news_id) >= parseInt(card.news_id)) return "";
    // if (parseInt(this.props.user.aid) != 5) return "";   
    return (
      <div class="modal modal-news fade black-overlay news-overlay show d-block" onClick={this.close}>                                    
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content" onClick={e => e.stopPropagation()}>
            <div class="modal-header d-none">
              <i class="fa fa-close news-popup-close" onClick={this.close}></i>
              <div class="text-right w-100">
                <span class="news-card-date">{moment(card.date*1000).format("DD MMM YYYY")}</span>
                <span class="news-card-author ml-2">by {card.author_name || ""}</span>                
              </div>
            </div>
            <div class="modal-body p-4 news-card-content">              
              <Container
                el={card.contentObj}
                content={card.contentObj.content}
                parent={this}          
                root={this}
                mode="render" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

import api from 'src/actions/api'
import setState from 'src/actions/state'
import { connect } from 'react-redux'

export default connect(function (state) {
  let apiState = state.api["news_find_by_user"] || state.api.initial
  let items = apiState.items || []
  items = items.map(item => {
    if (!item.contentObj) item.contentObj = parseContent(item.content,true)
    return item;
  })
  items = items.filter(item => item.contentObj.type == "container")
  return {
    apiState: apiState,
    items: items,
    state: state.state["news_popup"] || state.state.initial,
    user: state.session.user
  }
}, {
  api, 
  setState: setState("news_popup"),
})(Component)  



// <div class="popover fade show" role="tooltip" id="popover245105" style="will-change: transform; position: absolute; transform: translate3d(630px, 1430px, 0px); top: 0px; left: 0px;" x-placement="right"><div class="arrow" style="top: 34px;"></div><h3 class="popover-header">Popover title</h3><div class="popover-body">And here's some amazing content. It's very engaging. Right?</div></div>